import { useEffect, useState } from 'react';
import './App.scss';
import vidaaxtvoe from './images/tvoexvidaa.png';

import AlreadyInstalled from './components/AlreadyInstalled';
import DownloadButton from './components/DownloadButton';
import FooterContent from './components/FooterContent';
import NotHisense from './components/NotHisense';
import Success from './components/Success';
import UnableToInstall from './components/UnableToInstall';
import widerLogo from './images/wideLogo.png';
import installFunction from './utils/installFunction';
import installNewApp from './utils/installNewApp';
import olderInstallFunction from './utils/olderInstallFunction';
import olderInstallNewApp from './utils/olderInstallNewApp';

function App() {
  const [downloadStatus, setDownloadStatus] = useState(null);

  useEffect(() => {
    // Определение, подходит ли браузер для установки

    if (typeof window.Hisense_GetCountryCode === 'function') {
      if (
        typeof Hisense_installApp === 'function' || // 5–8
        typeof window.HiUtils_createRequest === 'function' || // 9+
        typeof window.HiBrowser != 'undefined' // < 5
      ) {
        setDownloadStatus('Ready');
      } else {
        setDownloadStatus('Impossible');
      }
    } else {
      setDownloadStatus('NotHisense');
    }
  }, []);

  const onClick = () => {
    const preview = 'https://app.tvoe.live/img/touch-logo.jpg';
    const widePreview = widerLogo;

    // 5 и выше
    if (window?.Hisense_installApp) installFunction(preview, setDownloadStatus);

    // < 5
    if (window.HiBrowser) olderInstallFunction(widePreview, setDownloadStatus);
  };

  const newAppOnClick = () => {
    const preview = 'https://app.tvoe.live/img/touch-logo.jpg';
    const widePreview = widerLogo;

    // 5 и выше
    if (window?.Hisense_installApp) installNewApp(preview, setDownloadStatus);

    // < 5
    if (window.HiBrowser) olderInstallNewApp(widePreview, setDownloadStatus);
  };

  const downloadState = {
    Ready: <DownloadButton onClick={onClick} newAppOnClick={newAppOnClick} />,
    Success: <Success />,
    NotHisense: <NotHisense />,
    Impossible: <UnableToInstall />,
    AlreadyInstalled: <AlreadyInstalled />,
  };

  return (
    <div className='flex flex-col h-screen'>
      <header className='flex justify-center items-center my-6 h-20'>
        <img src={vidaaxtvoe} alt={'TVOЁ'} width={420} />
      </header>

      <div className='flex flex-col justify-center items-center gap-4 h-full'>
        <div className='flex justify-center items-center'>
          {downloadState[downloadStatus]}
        </div>
      </div>

      <FooterContent />
    </div>
  );
}

export default App;

